<template>
  <div>
    <div v-if="minimize">
      <div class="rep_minimize">
        <b class="rep_title">{{ `${form.firstname} ${form.lastname} ` }} </b>
        <p class="rep_desc_min"></p>
        <p class="rep_desc">
          {{ `${form.phone_number}` }}
        </p>
        <br />
        <div class="col-xs-12">
          <div
            class="pane-list-add"
            style="float: left !important;"
            @click="goToEdit()"
          >
            <p>Изменить <b>данные</b></p>
          </div>
          <div
            class="pane-list-add"
            style="color: rgba(255, 255, 255, 0.6)!important; "
            @click="goToDelete()"
          >
            <p>Удалить <b>данные</b></p>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <register-title class="form__title">
        Сведения о <br />
        {{ is_rep_type ? "представителе" : "бенефициаре" }}
      </register-title>
      <div v-if="is_legal_ask">
        <form @submit.prevent="nextBenStep">
          <div style="color:white;">
            <input
              type="checkbox"
              v-model="form.is_owner"
              true-value="1"
              false-value="0"
            />
            В случае наличия физического лица, в структуре собственности,
            владеющего более 10% доли просим заполнить форму
          </div>
          <br />
          <div style="color:white;">
            <input
              type="checkbox"
              v-model="form.is_other_body_control"
              true-value="1"
              false-value="0"
            />
            В случае наличия физического лица, осуществляющего контроль над
            клиентом иным образом
          </div>
          <br />
          <div style="color:white;">
            <input
              type="checkbox"
              v-model="form.is_other_body_interests"
              true-value="1"
              false-value="0"
            />
            В случае наличия физического лица, в интересах которого
            устанавливаются деловые отношения
          </div>
          <div class="row reverse-xs">
            <div class="col-xs-12 col-sm-6">
              <router-link
                tag="button"
                :to="{ name: 'representatives-info-list' }"
                class="button form__button"
              >
                Назад
              </router-link>
            </div>
            <div class="col-xs-12 col-sm-6">
              <button class="button filled form__button" @click="nextBenStep">
                Далее
              </button>
            </div>
          </div>
        </form>
      </div>
      <form @submit.prevent="handleSubmit" v-else>
        <!------------------------------------  Personal Info  ----------------->
        <register-input
          v-model="form.lastname"
          componentID="full-name"
          label="Фамилия"
          inputType="text"
          inputPlaceholder="Фамилия"
          :isRequired="true"
          class="form__input"
        />
        <register-input
          v-model="form.firstname"
          componentID="full-name"
          label="Имя"
          inputType="text"
          inputPlaceholder="Имя"
          :isRequired="true"
          class="form__input"
        />
        <register-input
          v-model="form.middlename"
          componentID="full-name"
          label="Отчество"
          inputType="text"
          inputPlaceholder="Отчество"
          :isRequired="false"
          class="form__input"
        />
        <register-input
          v-model="form.birth_date"
          inputType="date"
          componentID="birth-date"
          label="Дата рождения"
          :maxDate="new Date()"
          :isRequired="true"
          class="form__input"
        />
        <register-input
          v-model="form.birth_place"
          componentID="birth-place"
          label="Место рождения"
          inputType="text"
          inputPlaceholder="Место рождения"
          :isRequired="true"
          class="form__input"
        />
        <hr class="horizontal-line" />
        <!------------------------------------  CITIZEN ASK  ----------------->
        <label class="label" style="text-align: center">
          Страна проживания
        </label>
        <exp-select
          :options="registrationCountryList()"
          v-model="form.citizenship"
          @change="value => (citizenship_code = value)"
          title="Выберите страну"
        ></exp-select>
        <!------------------------------------  TAX ASK  ----------------->
        <div v-if="!is_rep_type">
          <label class="label" style="text-align: center"
            >Налоговое резидентство</label
          >
          <exp-select
            :options="registrationCountryList()"
            v-model="form.tax_residency"
            title="Выберите страну"
          ></exp-select>
          <register-input
            v-model="form.tax_number"
            componentID="tax_number"
            inputType="text"
            label="Номер налогплатежа"
            inputPlaceholder="Номер налогплатежа"
            :isRequired="false"
            class="form__input"
          />
        </div>
        <!------------------------------------  CITIZEN DOCS ----------------->
        <br />
        <div>
          <register-input
            label="ИИН"
            componentID="iin"
            inputPlaceholder="ИИН"
            :isRequired="true"
            class="form__input"
            :inputMaxLength="12"
            v-model="form.iin"
          />
          <p
            class="login-form__error"
            v-if="form.iin && form.iin.length == 12 && !validateIin(form.iin)"
          >
            Неверный ИИН
          </p>
          <label class="label" style="text-align: center">
            Вид документа
          </label>
          <exp-select
            :options="registrationDocumentTypesList"
            v-model="form.document_type"
            title="Выберите вид документа"
            @change="(form.document_number = ''), (form.document_serial = '')"
          ></exp-select>
          <register-input
            v-model="form.document_serial"
            componentID="series"
            inputType="text"
            label="Серия"
            :isRequired="false"
            class="form__input"
          />
          <label class="label">
            Номер документа, удостоверяющего личность
            <span class="red">*</span>
          </label>
          <input
            type="text"
            class="input form__input wide"
            placeholder="Номер документа, удостоверяющего личность"
            required
            v-model="form.document_number"
            @keyup="formatDocNumber"
            @blur="formatDocNumber"
          />
          <register-input
            v-model="form.document_issued_at"
            inputType="date"
            componentID="identification-document-issue-date"
            label="Дата выдачи"
            :maxDate="new Date()"
            :isRequired="true"
            class="form__input"
          />
          <register-input
            v-model="form.document_valid_till"
            inputType="date"
            componentID="validity-date"
            label="Действителен до"
            :minDate="new Date()"
            :isRequired="true"
            class="form__input"
          />
          <register-input
            v-model="form.document_issuer"
            componentID="issuing-authority"
            label="Кем выдано"
            inputType="text"
            inputPlaceholder="Кем выдано"
            :isRequired="true"
            class="form__input"
          />
        </div>
        <!------------------------------------ NON CITIZEN DOCS ----------------->
        <div v-if="form.citizenship != 92">
          <hr class="horizontal-line" />
          <label class="label" style="text-align: center">
            Виза/Миграционная карта
          </label>
          <exp-select
            :options="visa_types"
            v-model="form.migration_document_type"
            title="Выберите страну"
          ></exp-select>
          <!-- VISA DOCS -->
          <div v-if="form.migration_document_type == 1">
            <register-input
              v-model="form.visa_number"
              componentID="visa-number"
              label="Номер визы"
              inputType="text"
              inputPlaceholder="Номер визы"
              :isRequired="true"
              class="form__input"
            />
            <register-input
              v-model="form.visa_issued_at"
              inputType="date"
              componentID="issue-date"
              label="Дата выдачи документа"
              :maxDate="new Date()"
              :isRequired="true"
              class="form__input"
            />
            <register-input
              v-model="form.visa_valid_till"
              inputType="date"
              componentID="validity-date"
              label="Документ годен до"
              :minDate="new Date()"
              :isRequired="true"
              class="form__input"
            />
          </div>
          <!-- Migration Docs -->
          <div v-else>
            <register-input
              v-model="form.migration_card_number"
              componentID="migration-card-number"
              label="Номер миграционной карты"
              inputType="text"
              inputPlaceholder="Номер миграционной карты"
              :isRequired="true"
              class="form__input"
            />
            <register-input
              v-model="form.migration_card_issued_at"
              inputType="date"
              componentID="issue-date"
              label="Дата выдачи документа"
              :maxDate="new Date()"
              :isRequired="true"
              class="form__input"
            />
            <register-input
              v-model="form.migration_card_valid_till"
              inputType="date"
              componentID="validity-date"
              label="Документ годен до"
              :minDate="new Date()"
              :isRequired="true"
              class="form__input"
            />
          </div>
        </div>
        <hr class="horizontal-line" />
        <!------------------------------------ Addresses & Phone ----------------->
        <register-input
          v-model="form.residence_address"
          componentID="registration-address"
          label="Адрес места жительства (регистрации)"
          inputType="text"
          inputPlaceholder="Адрес места жительства (регистрации)"
          :isRequired="true"
          class="form__input"
        />
        <register-input
          v-model="form.actual_address"
          componentID="actual-address"
          label="Фактический адрес места жительства"
          inputType="text"
          inputPlaceholder="Фактический адрес места жительства"
          :isRequired="true"
          class="form__input"
        />
        <div class="input-container">
          <label for="user-phone" class="label">
            Мобильный номер
            <span class="red">*</span>
          </label>
          <input
            type="tel"
            class="input form__input"
            placeholder="Мобильный номер"
            required
            maxlength="16"
            id="user-phone"
            v-model="form.phone_number"
            @keyup="formatPhone"
            @blur="formatPhone"
          />
        </div>
        <hr class="horizontal-line" />
        <!------------------------------------ Representative ----------------->
        <div v-if="is_rep_type">
          <register-input
            v-model="form.representative_number"
            componentID="client-action-document-number"
            label="Номер документа на совершение действий от клиента"
            inputType="text"
            inputPlaceholder="Номер документа на совершение действий от клиента"
            :isRequired="true"
            class="form__input"
          />
          <register-input
            v-model="form.representative_issued_at"
            inputType="date"
            componentID="client-action-document-issue-date"
            label="Дата выдачи (подписания) документа"
            :maxDate="new Date()"
            :isRequired="true"
            class="form__input"
          />
          <register-input
            v-model="form.representative_valid_till"
            inputType="date"
            componentID="client-action-document-validity-date"
            label="Срок действия документа"
            :minDate="new Date()"
            :isRequired="true"
            class="form__input"
          />
          <hr class="horizontal-line" />
        </div>

        <!------------------------------------ Notary ----------------->
        <div v-if="is_rep_type">
          <register-input
            v-model="form.notary_name"
            componentID="notary-full-name"
            label="Сведения о нотариусе, заверившем документ (ФИО)"
            inputType="text"
            inputPlaceholder="Сведения о нотариусе, заверившем документ (ФИО)"
            :isRequired="true"
            class="form__input"
          />
          <register-input
            v-model="form.notary_license_number"
            componentID="notary-license-number"
            label="Номер лицензии на осуществление нотариальной деятельности"
            inputType="text"
            inputPlaceholder="Номер лицензии на осуществление нотариальной деятельности"
            :isRequired="true"
            class="form__input"
          />
          <register-input
            v-model="form.notary_license_issued_at"
            inputType="date"
            componentID="notary-license-issue-date"
            label="Дата выдачи лицензии на осуществление нотариальной деятельности"
            :maxDate="new Date()"
            :isRequired="true"
            class="form__input"
          />
        </div>
        <button class="button filled form__button">Подтвердить</button>
      </form>
    </div>
  </div>
</template>
<style scoped></style>
<script>
const api_cases = {
  representative: {
    url: "user/representatives",
    collection_key: "representatives",
    data: {}
  },
  beneficiar: {
    url: "user/beneficiar",
    collection_key: "beneficiars",
    data: {}
  }
};
import mn from "moment";
import { FhsAxios } from "../../../services/axios";

import RegFormMixin from "../form_mixin";
export default {
  props: {
    minimize: {
      default: false,
      required: false,
      type: Boolean
    },
    form_data: {
      default: null,
      required: false,
      type: Object
    },
    form_data_list: {
      default: null,
      required: false,
      type: Array
    },
    form_data_key: {
      default: null,
      required: true,
      type: String
    },
    form_data_index: {
      default: null,
      required: false,
      type: Number
    },
    user_profile: Object
  },
  watch: {
    user_profile: function(value) {
      this.fetchForm();
    }
  },
  data() {
    return {
      citizenship_code: null,
      doc_type: "visa",
      old_form: null,
      legal_ask: true,
      form: {
        // KAZ citizens
        firstname: null,
        lastname: null,
        middlename: null,
        iin: "",
        birth_date: null,
        birth_place: null,
        //
        citizenship: null,
        //
        document_serial: null,
        document_number: null,
        document_type: null,
        document_issued_at: null,
        document_valid_till: null,
        document_issuer: null,
        //
        residence_address: null,
        actual_address: null,
        //
        phone_number: "",
        //
        representative_number: null,
        representative_issued_at: null,
        representative_valid_till: null,
        //
        notary_name: null,
        notary_license_number: null,
        notary_license_issued_at: null,
        //
        additional_info: null,
        // VISA citizens
        visa_number: null,
        visa_issued_at: null,
        visa_valid_till: null,
        // MIGRATION citizens
        migration_document_type: null,
        migration_card_number: null,
        migration_card_issued_at: null,
        migration_card_valid_till: null,
        is_owner: 0,
        is_other_body_control: 0,
        is_other_body_interests: 0
      },
      form_b: {
        beneficiar_iin: "iin",
        beneficiar_lastname: "lastname",
        beneficiar_firstname: "firstname",
        beneficiar_middlename: "middlename",
        beneficiar_date_birth: "birth_date",
        beneficiar_document_type: "document_type",
        beneficiar_document_serial: "document_serial",
        beneficiar_document_number: "document_number",
        beneficiar_document_issued_at: "document_issued_at",
        beneficiar_document_issuer: "document_issuer",
        beneficiar_document_valid_till: "document_valid_till",
        beneficiar_citizenship: "citizenship",
        beneficiar_tax_residency: "tax_residency",
        beneficiar_tax_number: "tax_number",
        beneficiar_viza_type: "migration_document_type",
        beneficiar_viza_number: "visa_number",
        beneficiar_viza_issued_at: "visa_issued_at",
        beneficiar_viza_valid_till: "visa_valid_till",
        phone: "phone_number",
        is_owner: "is_owner",
        is_other_body_control: "is_other_body_control",
        is_other_body_interests: "is_other_body_interests"
      },
      form_dates: [
        "birth_date",
        "document_issued_at",
        "document_valid_till",
        "representative_issued_at",
        "representative_valid_till",
        "notary_license_issued_at",
        "visa_issued_at",
        "visa_valid_till",
        "migration_card_issued_at",
        "migration_card_valid_till"
      ]
    };
  },
  mixins: [RegFormMixin],
  filters: {
    formatDateMn(value, arg) {
      return mn(value).format(arg);
    }
  },
  computed: {
    is_legal_ask() {
      return this.legal_ask && !this.is_rep_type && this.isUserLegal;
    },
    is_rep_detail() {
      return (
        this.$route.params.rep_index !== undefined &&
        this.$route.params.rep_index !== null
      );
    },
    is_rep_type() {
      return this.form_data_key === "representative";
    }
  },
  methods: {
    nextBenStep() {
      let options =
        this.form.is_owner ||
        this.form.is_other_body_control ||
        this.form.is_other_body_interests;
      // console.log(options);
      if (options) this.legal_ask = !options;
      else {
        this.$toasted.show("Выберите поле");
      }
    },
    goToDelete() {
      if (this.is_rep_type) {
        let payload = JSON.parse(JSON.stringify(this.form_data_list));
        payload.splice(this.form_data_index, 1);
        this.$emit("deleted", this.form_data_index);
        let cases = api_cases;
        cases["representative"].data = payload;
        this.saveData(cases["representative"]);
      } else {
        let url = `user/beneficiar-delete`;
        FhsAxios.get(url, {
          data: {}
        }).then(res => {
          if (res.data.status) {
            this.$toasted.success("Данные сохранены");
            this.$emit("deleted", true);
            return;
          }
          this.$emit("deleted", false);
          this.$toasted.error("Произошла ошибка");
          this.$emit("loading-status", false);
        });
      }
    },
    goToEdit() {
      this.$router.push({
        name: "representatives-form-edit",
        params: {
          rep_type: this.form_data_key,
          rep_index: this.form_data_index
        }
      });
    },
    formatDocNumber() {
      // console.log(this.isKazDoc(this.form.document_type));
      if (this.isKazDoc(this.form.document_type)) {
        this.form.document_number = this.form.document_number.replace(
          /\D/g,
          ""
        );
        this.form.document_number = this.form.document_number.substr(0, 9);
      }
    },
    formatPhone() {
      let num = this.form.phone_number.replace(/\D/g, "").split(/(?=.)/);
      let i = num.length - 1;
      if (0 <= i) num.unshift("+");
      if (1 <= i) num.splice(2, 0, " ");
      if (4 <= i) num.splice(6, 0, " ");
      if (7 <= i) num.splice(10, 0, "-");
      if (9 <= i) num.splice(13, 0, "-");
      this.form.phone_number = num.join("");
    },
    isFormChanged() {
      return JSON.stringify(this.old_form) !== JSON.stringify(this.form);
    },
    fetchForm() {
      try {
        if (this.form_data) {
          if (this.is_rep_type) {
            // console.log(this.form_data);
            Object.keys(this.form_data).map(key => {
              if (key in this.form) {
                this.form[key] = this.form_data[key];
              }
            });
            delete this.form.tax_residency;
            delete this.form.tax_number;
          } else {
            Object.keys(this.form_data).map(key => {
              this.form[this.form_b[key]] = this.form_data[key];
            });
            this.form.tax_residency = this.form_data.beneficiar_tax_residency;
            this.form.tax_number = this.form_data.beneficiar_tax_number;
          }
          this.form_dates.forEach(date => {
            if (this.form[date]) {
              this.form[date] = this.dateFormat(this.form[date]);
            }
          });
        }
        this.old_form = JSON.parse(JSON.stringify(this.form));
      } catch (e) {
        console.log(e);
        // ERROR HANDLER
      }
    },
    nextStep() {
      this.$router.push({ name: "representatives-info-list" });
    },
    saveData(request_case) {
      // console.log(request_case);
      let url = `${request_case.url}`;
      FhsAxios.post(url, request_case.data).then(res => {
        if (res.data.status) {
          this.$toasted.success("Данные сохранены");
          this.nextStep();
          return;
        }
        this.$toasted.error("Произошла ошибка");
        this.$emit("loading-status", false);
      });
    },
    prepareForSaveData() {
      const form = JSON.parse(JSON.stringify(this.form));
      this.form_dates.forEach(date => {
        if (form[date]) {
          form[date] = this.dateReFormat(form[date]);
        }
      });
      if (!this.is_rep_type) {
        const form_ben = {};
        Object.keys(this.form_b).map(field => {
          form_ben[field] = form[this.form_b[field]];
        });
        let beneficiar_payload = api_cases.beneficiar;
        beneficiar_payload.data = form_ben;
        this.saveData(beneficiar_payload);
      } else {
        let data_list = JSON.parse(JSON.stringify(this.form_data_list));
        let representative_payload = api_cases.representative;
        representative_payload.data = data_list;
        if (this.$route.name === "representatives-form-edit") {
          representative_payload.data[this.$route.params.rep_index] = form;
        } else {
          delete form.is_owner;
          delete form.is_other_body_interests;
          delete form.is_other_body_control;
          representative_payload.data.push(form);
        }
        this.saveData(representative_payload);
      }
    },
    handleSubmit() {
      if (!this.isFormChanged()) {
        this.nextStep();
      } else {
        this.prepareForSaveData();
      }
    }
  },
  beforeMount() {
    this.fetchForm();
  }
};
</script>
